<template>
  <div id="app">
    <div class="columns is-variable is-3">
      <div class="column is-full">
        <div
          id="left-col-wrapper"
          :style="{ 'max-width': gridSize[0] * gridScale + 'px' }"
        >
          <div id="logo-container">
            <img :src="require('./assets/pysnaike.png')" alt="" />
          </div>
          <br />
          <div id="drawboard" class="has-text-centered">
            <h5 class="title is-5">Draw digits</h5>
            <h6 class="subtitle is-6">
              Let PySnaike AI guess your<br />
              hand-drawn digits in real time!
            </h6>
            <canvas
              id="mainCanvas"
              @mousemove="draw"
              @mousedown="beginDrawing"
              @mouseup="stopDrawing"
              ref="mainCanvas"
              :width="gridSize[0] * gridScale"
              :height="gridSize[1] * gridScale"
            ></canvas>
          </div>
          <div id="tools">
            <div id="tools-left">
              <input
                class="button"
                type="button"
                :disabled="tool === 'pencil'"
                @click="pencil"
                value="Pencil"
              />
              <input
                class="button"
                type="button"
                :disabled="tool === 'eraser'"
                @click="eraser"
                value="Eraser"
              />
            </div>
            <div id="tools-right">
              <input
                class="button"
                type="button"
                @click="clear"
                value="Clear"
              />
            </div>
          </div>
          <hr />
          <div class="has-text-centered">
            <h5 class="subtitle is-5">AI guess:</h5>
            <div class="result-wrapper">
              <h3 v-if="isGuessing == false" class="title is-3">
                {{ aiGuess }}
              </h3>
              <div id="loader-wrapper" v-else>
                <div
                  v-if="isGuessing == true"
                  id="guess-loader"
                  class="loader is-loading"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- width="1186px"
          height="691px" -->
    <!-- <div class="column">
      <div class="column has-text-centered">
        <iframe src="https://edusde-my.sharepoint.com/personal/kasp262e_edu_sde_dk/_layouts/15/Doc.aspx?sourcedoc={b5957b43-8405-43ad-b51b-f447226da39d}&amp;action=embedview&amp;wdAr=1.3333333333333333" width="722px" height="565px" frameborder="0">This is an embedded <a target="_blank" href="https://office.com">Microsoft Office</a> presentation, powered by <a target="_blank" href="https://office.com/webapps">Office</a>.</iframe>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
const { PORT } = process.env;
console.log(PORT);
// const API_BASE_URL = `http://localhost:3000`;
const API_BASE_URL = `https://pysnaike-flask-vercel.vercel.app`;
console.log(API_BASE_URL);
export default {
  name: "App",
  data() {
    return {
      grid: [],
      gridSize: [28, 28],
      gridScale: 8,
      canvas: null,
      isDrawing: false,
      message: "",
      aiGuess: null,
      isGuessing: null,
      tool: "pencil",
    };
  },
  mounted() {
    this.canvas = this.$refs["mainCanvas"].getContext("2d");
    this.$refs["mainCanvas"];
    this.canvas.fillStyle = "white";
    this.canvas.fillRect(
      0,
      0,
      this.gridSize[0] * this.gridScale,
      this.gridSize[1] * this.gridScale
    );
  },
  created() {
    this.clearGrid();
    console.log(this.grid);
  },
  methods: {
    drawLine(x1, y1, x2, y2) {
      let ctx = this.canvas;
      ctx.beginPath();
      ctx.strokeStyle = "black";
      ctx.lineWidth = 1;
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.closePath();
    },
    drawGrid() {
      this.canvas.fillStyle = "white";
      this.canvas.fillRect(
        0,
        0,
        this.gridSize[0] * this.gridScale,
        this.gridSize[1] * this.gridScale
      );
      for (let y = 0; y < this.gridSize[1]; y++) {
        for (let x = 0; x < this.gridSize[0]; x++) {
          if (this.grid[y][x] == 1) {
            this.canvas.beginPath();
            this.canvas.fillStyle = "black";
            this.canvas.fillRect(
              x * this.gridScale,
              y * this.gridScale,
              this.gridScale,
              this.gridScale
            );
            this.canvas.strokeStyle = "black";
            this.canvas.stroke();
          }
        }
      }
    },
    draw(e) {
      if (this.isDrawing) {
        let x_coord = parseInt(e.offsetX / this.gridScale);
        let y_coord = parseInt(e.offsetY / this.gridScale);
        let value = this.tool === "pencil" ? 1 : 0;
        this.grid[y_coord][x_coord] = value;
        // this.message = `${x_coord}, ${y_coord}`;
        this.drawGrid();
      }
    },
    beginDrawing() {
      this.isDrawing = true;
    },
    stopDrawing() {
      this.isDrawing = false;
      this.isGuessing = true;
      this.guessDigit();
    },
    clearGrid() {
      for (let y = 0; y < this.gridSize[1]; y++) {
        this.grid.push([]);
        for (let x = 0; x < this.gridSize[0]; x++) {
          this.grid[y].push(0);
        }
      }
    },
    clear() {
      this.grid = [];
      console.log(this.grid);
      this.clearGrid();
      this.drawGrid();
      this.tool = "pencil";
      this.aiGuess = null;
    },
    pencil() {
      this.tool = "pencil";
    },
    eraser() {
      this.tool = "eraser";
    },
    guessDigit() {
      console.log(API_BASE_URL);
      axios
        .post(`${API_BASE_URL}/api/aiguess`, {
          data: { inputdata: JSON.stringify(this.grid) },
          methods: ["post"],
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log(response);
          this.aiGuess = response.data.AIGUESS;
          this.isGuessing = false;
        })
        .catch((error) => {
          this.isGuessing = false;
          console.log(error);
        });
    },
  },
};
</script>

<style>
html,
body {
  background: #f2f6fa;
}

#app {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

#mainCanvas {
  border: 1px solid grey;
}

#tools {
  width: 100%;
  display: flex;
  /* align-items: flex-end; */
  justify-content: space-between;
}

#tools-right .result-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 30px;
}

.result-wrapper * {
  height: 30px;
}
#loader-wrapper {
  display: flex;
  justify-content: center;
}
#guess-loader {
  height: 30px;
  width: 30px;
}

#logo-container {
  width: auto;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

#logo-container img {
  width: 80%;
}

#left-col-wrapper {
  margin: 0 auto;
}

@media screen and (min-width: 769px) {
  html,
  body {
    height: 100%;
  }
}
</style>
